import { render } from "./SupplierContactTable.vue?vue&type=template&id=47b467cd&scoped=true&ts=true&lang=pug"
import script from "./SupplierContactTable.vue?vue&type=script&lang=ts"
export * from "./SupplierContactTable.vue?vue&type=script&lang=ts"

import "./SupplierContactTable.vue?vue&type=style&index=0&id=47b467cd&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b467cd"]])

export default __exports__